import { coreUsersAllGetAsyncSlice } from './get';
import { updateUsersAllSyncSlice } from './update';

export const { receiveGetCoreUsersAll, repeatGetCoreUsersAll, requestGetCoreUsersAll, resetGetCoreUsersAll } =
	coreUsersAllGetAsyncSlice.asyncActionCreators;

export const updateUser = updateUsersAllSyncSlice.syncActionCreator;
